import { Tooltip } from "antd-v5";
import useEntityNavigator, {
  EntityNavigatorParams,
} from "hooks/useEntityNavigator";
import React, { memo, useEffect } from "react";

import ACButtonGroup, { ACButtonGroupItem } from "ac-components/ACButtonGroup";
import ChevronDownIcon from "ac-components/ac-icons/ChevronDownIcon";
import ChevronUpIcon from "ac-components/ac-icons/ChevronUpIcon";

function ACEntityNavigator({
  navigatorParams,
  className,
  onEntityChange,
  containerClassName,
}: {
  navigatorParams: EntityNavigatorParams;
  className?: string;
  onEntityChange: (id: number | string, page: number) => void;
  containerClassName?: string;
}) {
  const entityNavigator = useEntityNavigator({
    ...navigatorParams,
    onEntityChange,
  });

  useEffect(() => {
    if (!containerClassName) {
      return;
    }
    const container = document.getElementsByClassName(
      containerClassName,
    )[0] as HTMLElement;
    if (!container) {
      return;
    }
    setTimeout(() => container.focus(), 1000);

    const keyDown = (e: any) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ["arrowup"].includes(e.key.toLowerCase()) &&
        entityNavigator.hasPrev
      ) {
        e.preventDefault();
        entityNavigator.prev();
      } else if (
        (e.ctrlKey || e.metaKey) &&
        ["arrowdown"].includes(e.key.toLowerCase()) &&
        entityNavigator.hasNext
      ) {
        e.preventDefault();
        entityNavigator.next();
      }
    };
    container.addEventListener("keydown", keyDown);

    return () => container.removeEventListener("keydown", keyDown);
  }, [containerClassName, entityNavigator]);

  return (
    <ACButtonGroup size="md" className={className}>
      <Tooltip
        title={
          <>
            Keyboard Shortcut: <br /> Ctrl/Cmd + Arrow Up
          </>
        }
      >
        <ACButtonGroupItem
          onClick={entityNavigator.prev}
          disabled={!entityNavigator.hasPrev}
        >
          <ChevronUpIcon />
        </ACButtonGroupItem>
      </Tooltip>
      <Tooltip
        title={
          <>
            Keyboard Shortcut: <br /> Ctrl/Cmd + Arrow Down
          </>
        }
      >
        <ACButtonGroupItem
          onClick={entityNavigator.next}
          disabled={!entityNavigator.hasNext}
        >
          <ChevronDownIcon />
        </ACButtonGroupItem>
      </Tooltip>
    </ACButtonGroup>
  );
}

export default memo(ACEntityNavigator);
